import React, { useState, useEffect } from 'react';
import styles from './SubscriptionCancleReasonModal.module.css';

import { InnocodePaymentCardInfo, InnocodePaymentPasswordButton, InnocodePaymentPasswordDot } from '@intsoft/innocode-payment';
import { InnocodeButton, InnocodeCheckmark, InnocodeDropdown, InnocodeInput, InnocodeRadio, InnocodeRadiobox } from '@intsoft/innocode-core';



/* 구독 해지 모달 */
interface SubscriptionCancleReasonModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm?: (data: any) => void;
}

export const SubscriptionCancleReasonModal: React.FC<SubscriptionCancleReasonModalProps> = (props: SubscriptionCancleReasonModalProps) => {

    const [reason, setReason] = useState<string>('');
    const [otherReason, setOtherReason] = useState<string>('');
    const option = [
        {
            value: "REASON_1",
            label: "멤버십 가격이 부담돼요.",
        },
        {
            value: "REASON_2",
            label: "다른 서비스를 이용해요.",
        },
        {
            value: "REASON_3",
            label: "다른 멤버십을 사용하려고 해요.",
        },
        {
            value: "REASON_4",
            label: "멤버십 혜택을 잘 이용하지 않고 있어요.",
        },
    ];

    const handleConfirm = () => {
        if (reason === '') {
            return;
        } else {
            props.onConfirm?.({
                reason: reason,
                otherReason: otherReason,
            });
            props.onClose();
        }
    }
    return (
        <div className={styles.layoutContainer}>
            <div className={styles.editorHeader}>
                <div className={styles.editorHeaderCloseButton} onClick={props.onClose}>
                    <svg className="w-6 h-6 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" onClick={props.onClose} style={{ cursor: 'pointer' }}>
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18 17.94 6M18 18 6.06 6" />
                    </svg>
                </div>
            </div>
            <div className={styles.scrollContentArea}>
                <div className={styles.minHeightArea}>
                    <div className={styles.contentAreaWrapper}>
                        <div className={styles.contentArea}>
                            <div className={styles.contentAreaTitle}>
                                <h1 className={`innocode-typography--headline-sm innocode-typography--bold ${styles.contentAreaTitleText}`}>
                                    구독을 해지하는 이유를 알려주세요.
                                </h1>
                                <p className={styles.contentAreaTitleDescription}>
                                    멤버십을 해지하시는 이유를 알 수 있을까요? 여러분의 의견을 담아<br />더 좋은 서비스로 성장하기 위한 자료로 사용됩니다.
                                </p>
                            </div>
                            <div className={styles.subscriptionCancleWrapper}>
                                <div className={styles.subscriptionCancleItemWrapper}>
                                    <div className={styles.subscriptionCancleItemList}>
                                        {option.map((item) => (
                                            <InnocodeRadiobox onClick={() => setReason(item.value)} leadingIcon={true} size={"md"} checked={reason === item.value} title={item.label ?? ''} value={item.value} />
                                        ))}
                                        <div className={styles.subscriptionCancleItem}>
                                            <InnocodeRadio checked={reason === 'REASON_5'} onChange={() => setReason('REASON_5')}></InnocodeRadio>
                                            <InnocodeInput onClick={() => setReason('REASON_5')} placeholder="기타" value={otherReason} onChange={(e) => setOtherReason(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.actionButtonWrapper}>
                                <InnocodeButton size={"xl"} className={styles.actionButton} theme="solid" designType={reason === '' ? 'assistive' : 'primary'} onClick={handleConfirm}>구독 해지</InnocodeButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};